/**
 * product-image-magnifier.js
 *
 * Lupa flotante para la imagen principal del producto — el zoom aparece
 * justo donde está el cursor. Independiente de los componentes internos de
 * Thinker. Solo lee:
 *   - clase .product-media-container--zoomable.product-media-container--image
 *   - el <img class="product-media__image"> dentro de ese contenedor
 *   - el atributo data_max_resolution de esa imagen (URL en alta resolución)
 *
 * IMPORTANTE: ya no usa un overlay físico encima de la imagen. La versión
 * anterior tapaba el <img> real con un <div>, lo que rompía "Guardar imagen
 * como..." en Chrome (el clic derecho caía sobre el div, no sobre la
 * imagen). Ahora el <img> siempre es el objetivo real de todos los eventos
 * del mouse — clic derecho funciona normal — y el clic izquierdo (que abre
 * el modal de Thinker) se bloquea con un listener en FASE DE CAPTURA, que
 * se ejecuta antes de que el clic le llegue a cualquier elemento, sin
 * necesidad de tapar nada físicamente.
 */
(function () {
  var ZOOM_FACTOR = 5;
  var BUBBLE_SIZE = 220;
  var CONTAINER_SELECTOR = '.product-media-container--zoomable.product-media-container--image';
  var IMAGE_SELECTOR = 'img.product-media__image';

  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!supportsHover) return;

  function initMagnifier(container) {
    if (container.dataset.magnifierInit) return;
    container.dataset.magnifierInit = 'true';

    var image = container.querySelector(IMAGE_SELECTOR);
    if (!image) return;

    var highResUrl = image.getAttribute('data_max_resolution');
    if (!highResUrl) return;

    container.style.position = container.style.position || 'relative';
    container.style.cursor = 'none';

    // La burbuja flotante: <img> real con object-fit: cover, para no
    // deformar la proporción de la foto. Ya no hay overlay debajo — el
    // <img> original queda completamente libre para clic derecho.
    var bubble = document.createElement('div');
    bubble.className = 'product-image-magnifier__bubble';
    bubble.style.width = BUBBLE_SIZE + 'px';
    bubble.style.height = BUBBLE_SIZE + 'px';

    var zoomImage = document.createElement('img');
    zoomImage.className = 'product-image-magnifier__zoom-image';
    zoomImage.src = highResUrl;
    zoomImage.alt = '';
    bubble.appendChild(zoomImage);

    document.body.appendChild(bubble);

    function updateBubble(event) {
      var rect = container.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      var zoomedWidth = rect.width * ZOOM_FACTOR;
      var zoomedHeight = rect.height * ZOOM_FACTOR;

      var offsetX = -(x * ZOOM_FACTOR - BUBBLE_SIZE / 2);
      var offsetY = -(y * ZOOM_FACTOR - BUBBLE_SIZE / 2);

      zoomImage.style.width = zoomedWidth + 'px';
      zoomImage.style.height = zoomedHeight + 'px';
      zoomImage.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';

      bubble.style.left = (event.clientX - BUBBLE_SIZE / 2) + 'px';
      bubble.style.top = (event.clientY - BUBBLE_SIZE / 2) + 'px';
    }

    // Los listeners de movimiento van directo en el contenedor — ya no
    // necesitan un overlay intermedio, porque no estamos capturando el
    // clic aquí (eso se mueve a fase de captura, ver abajo).
    container.addEventListener('mouseenter', function (event) {
      bubble.classList.add('is-active');
      updateBubble(event);
    });

    container.addEventListener('mousemove', updateBubble);

    container.addEventListener('mouseleave', function () {
      bubble.classList.remove('is-active');
    });

    // Bloquea SOLO el clic izquierdo dentro de esta imagen específica, en
    // fase de captura — se ejecuta antes de que el clic llegue al elemento
    // real que tiene el on:click de Thinker, sin tapar la imagen con nada.
    // El clic derecho (contextmenu) nunca pasa por aquí, así que "Guardar
    // imagen como..." sigue funcionando normal.
    container.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
      },
      true // fase de captura
    );
  }

  function initAll() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(initMagnifier);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(CONTAINER_SELECTOR)) {
          initMagnifier(node);
        }
        node.querySelectorAll && node.querySelectorAll(CONTAINER_SELECTOR).forEach(initMagnifier);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();